import { CSSProperties } from "react";
import { HashLoader } from "react-spinners";

export const Load = () => {
    const override: CSSProperties = {
        display: "block",
        margin: "0 auto",
        borderColor: "red",
    };

    const color = '#0097A7';

    return (
        <HashLoader data-component-id="src/components/common/Load.tsx:14:8" data-component-path="src/components/common/Load.tsx" data-component-line="14" data-component-end-line="22" data-component-file="Load.tsx" data-component-name="HashLoader" data-component-content="%7B%22elementName%22%3A%22HashLoader%22%2C%22className%22%3A%22text-cyan-700%22%7D"
            color={color}
            loading={true}
            cssOverride={override}
            size={50}
            aria-label="Loading Spinner"
            data-testid="loader"
            className="text-cyan-700"
        />
    )
}

export const LoadPopUp = () => {
    return (
        <div data-component-id="src/components/common/Load.tsx:28:8" data-component-path="src/components/common/Load.tsx" data-component-line="28" data-component-end-line="33" data-component-file="Load.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22fixed%20inset-0%20flex%20items-center%20justify-center%22%7D"
            className="fixed inset-0 flex items-center justify-center"
            style={{ transform: "translate(-50%, -50%)", top: "50%", left: "50%" }}
        >
            <Load data-component-id="src/components/common/Load.tsx:32:12" data-component-path="src/components/common/Load.tsx" data-component-line="32" data-component-end-line="32" data-component-file="Load.tsx" data-component-name="Load" data-component-content="%7B%22elementName%22%3A%22Load%22%7D" />
        </div>
    );
};

export const LoadDialog = (props: { isOpen: boolean }) => {
    const { isOpen } = props;

    if (!isOpen) return null;

    return (
        <div data-component-id="src/components/common/Load.tsx:43:8" data-component-path="src/components/common/Load.tsx" data-component-line="43" data-component-end-line="47" data-component-file="Load.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22fixed%20inset-0%20z-50%20flex%20items-center%20justify-center%20bg-black%2F50%22%7D" className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
            <div data-component-id="src/components/common/Load.tsx:44:12" data-component-path="src/components/common/Load.tsx" data-component-line="44" data-component-end-line="46" data-component-file="Load.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22bg-transparent%20rounded-lg%20p-6%22%7D" className="bg-transparent rounded-lg p-6">
                <LoadPopUp data-component-id="src/components/common/Load.tsx:45:16" data-component-path="src/components/common/Load.tsx" data-component-line="45" data-component-end-line="45" data-component-file="Load.tsx" data-component-name="LoadPopUp" data-component-content="%7B%22elementName%22%3A%22LoadPopUp%22%7D" />
            </div>
        </div>
    );
};